export abstract class Message {
    protected constructor(public readonly id: string) {}
}

export abstract class Event extends Message {}

export interface MessageHandler {
    handle(message: Message): void;
}

export interface EventHandler<TEvent extends Event = never> {
    handle: ((event: TEvent) => void) | (() => void);
}
